import React from 'react';
import { Col, Form, Input, Row, Typography } from 'antd';
import { useTranslation } from 'react-i18next';
import { TranslateFormLabel } from 'components/translateInputAddon';

const areaStyles = {
  height: 150,
};

const DescriptionSection = ({ isView, form }) => {
  const { t } = useTranslation();
  return (
    <Row gutter={24}>
      <Col span={6}>
        <Typography.Title level={3}>{t('Descrizione')}</Typography.Title>
      </Col>
      <Col span={6}>
        <Form.Item
          label={
            <TranslateFormLabel
              label={t('Descrizione IT')}
              form={form}
              sourceField='description_it'
              textKey='description'
              targetFields={{
                en: 'description_en',
                fr: 'description_fr',
              }}
              disabled={isView}
            />
          }
          name='description_it'
        >
          <Input.TextArea
            disabled={isView}
            style={areaStyles}
            placeholder={t('Inserisci testo')}
          />
        </Form.Item>
      </Col>
      <Col span={6}>
        <Form.Item label={t('Descrizione EN')} name='description_en'>
          <Input.TextArea
            disabled={isView}
            style={areaStyles}
            placeholder={t('Inserisci testo')}
          />
        </Form.Item>
      </Col>
      <Col span={6}>
        <Form.Item label={t('Descrizione FR')} name='description_fr'>
          <Input.TextArea
            disabled={isView}
            style={areaStyles}
            placeholder={t('Inserisci testo')}
          />
        </Form.Item>
      </Col>
    </Row>
  );
};

export default React.memo(DescriptionSection);
